import { needIndexComponent, parseInitDataAfterFetch, parseChartDataAfterFetch, unwrapJsonStringLayers } from './funcs'
import { normalizeCompositeTabUrlInset } from '@/utils/compositeScreen'
import { coerceSelectedIndicatorListOnChartViewData } from '@/utils/indicatorSelect'

/**
 * 将接口返回的大屏对象中的 chartViews 做 chartSet 解析与 chartViewData 填充（与 ScreenView.init 一致）
 * @param {object} res getScreenDataApi 返回值（会被就地修改）
 */
export function hydrateScreenChartViews (res) {
  if (!res || !Array.isArray(res.chartViews)) return
  res.chartViews.forEach(item => {
    item.chartSet = typeof item.chartSet === 'string' ? JSON.parse(item.chartSet) : (item.chartSet || {})
    if (Object.prototype.hasOwnProperty.call(item, 'chartColors')) {
      const legacy = item.chartColors
      if (legacy != null && legacy !== '' && legacy !== 'inherit' &&
          (item.chartSet.chartColors == null || item.chartSet.chartColors === '')) {
        item.chartSet.chartColors = legacy
      }
      delete item.chartColors
    }
    if ((needIndexComponent(item.chartComponent)) && item.chartSet?.dataSource === 'indicatorLib') {
      const parseData = JSON.parse(item.chartViewData.chartData)
      const initData = parseInitDataAfterFetch(item.chartViewData.initData)
      if (item.chartComponent === 'richText') {
        if (typeof parseData === 'string') {
          item.chartViewData = {
            ...item.chartViewData,
            initData,
            chartData: unwrapJsonStringLayers(parseData),
          }
        } else if (parseData && typeof parseData === 'object') {
          const { richTextBody, ...rest } = parseData
          item.chartViewData = {
            ...item.chartViewData,
            ...rest,
            initData,
            chartData: typeof richTextBody === 'string' ? unwrapJsonStringLayers(richTextBody) : '',
          }
        } else {
          item.chartViewData = {
            ...item.chartViewData,
            initData,
            chartData: '',
          }
        }
      } else {
        const chartData = Object.prototype.toString.call(parseData) === '[object Object]' ? parseData : {}
        item.chartViewData = {
          ...item.chartViewData,
          ...chartData,
          initData,
        }
      }
    } else {
      const chartData = parseChartDataAfterFetch(item.chartViewData.chartData, item.chartComponent)
      const initData = parseInitDataAfterFetch(item.chartViewData.initData)
      item.chartViewData = {
        ...item.chartViewData,
        chartData,
        initData,
      }
    }
    coerceSelectedIndicatorListOnChartViewData(item.chartViewData)
    /** 与 edit.vue 注册的 PascalCase 组件名一致；旧数据曾写 imageBlock 导致 :is 无法解析 */
    if (item.chartComponent === 'imageBlock') {
      item.chartComponentType = 'ImageBlock'
    }
    if (item.chartComponent === 'compositeTabBar') {
      item.chartComponentType = 'CompositeTabBar'
      // 接口/旧数据兼容：panel_sn -> panelSn（否则 view 模式会把未绑定子屏的 tab 全过滤掉）
      const tabs = item.chartSet?.tabs
      if (Array.isArray(tabs)) {
        tabs.forEach((t) => {
          if (!t) return
          // 旧数据兼容：不填 type 默认视为子屏
          if (t.type == null || t.type === '') t.type = 'panel'
          if ((t.panelSn == null || t.panelSn === '') && t.panel_sn != null && t.panel_sn !== '') {
            t.panelSn = t.panel_sn
          }
          if (String(t.type || 'panel').toLowerCase() === 'url') {
            t.urlInset = normalizeCompositeTabUrlInset(t)
          }
        })
      }
    }
    if (item.chartComponent === 'compositePanelHost') {
      item.chartComponentType = 'CompositePanelHost'
    }
    if (item.chartComponentType === 'IndependentNumber' && !item.chartSet.borderStyle?.numberBorderType) {
      item.chartSet.borderStyle.numberBorderType = 1
    }
    if (item.chartComponentType === 'BorderBlock' && !item.chartSet.chartStyle?.borderType) {
      item.chartSet.chartStyle.borderType = 1
    }
  })
}
